export default "__VITE_ASSET__o3MrXHpWRt$jlnVEVSGiZw__"